module.exports = __webpack_public_path__ + "img/motion_sensor.5cba8578.svg";